import { Home } from "views/website/home";
import { Signin } from "views/auth/signin";
import { Contact } from "views/website/contact";
import { Pricing } from "views/website/pricing";
import { Terms } from "views/website/terms";
import { Privacy } from "views/website/privacy";
import { PublicVerificationEntry } from "views/verification/public-verification-entry";
import { Tranche2Verification } from "views/verification/tranche2-page";
import { PublicRiskAssessmentView } from "views/verification/public-risk-assessment";
import { PublicEddView } from "views/verification/public-edd";
import { EULA } from "views/website/eula";
import { DocsPublicView } from "views/website/docs";
import { FinishVerification } from "views/website/finish";
import { ResponseView } from "views/verification/response";
import { PreVerificationFormView } from "views/verification/form";
import { ReportRequested } from "views/website/report-requested";
import { PreHsResponseFormView } from "views/verification/pre-hs-response";
import { HsResponseFormView } from "views/verification/hs-response";
import { McKinleyPlowmanResponse } from "views/verification/mckinley-plowman-response";
import { DemoITRResponse } from "views/verification/demo-itr-response";
import { SuperResponseFormView } from "views/verification/super-itr-response";
import { EfsFactFinderResponse } from "views/verification/efs-fact-finder-response";
import { ClientOnboardingFormView } from "views/verification/client-onboarding";
import { ClientOnboardingV2FormView } from "views/verification/client-onboarding-v2";
import { IntegrationTriggerConfirm } from "views/integration/trigger-confirm";
import { PublicIntakeStart } from "views/verification/public-intake-start";

// Client-facing routes carry skin: "identitycheck" — they keep the frozen
// IdentityCheck look (see src/css/tokens.css) while the staff app, sign-in,
// sign-up and marketing pages take the StackGo skin.
const Routes = [
  {
    path: "/",
    view: Signin,
    layout: "auth",
    title: "StackGo",
  },
  {
    path: "/contact",
    view: Contact,
    layout: "home",
    title: "Contact",
  },
  {
    path: "/pricing",
    view: Pricing,
    layout: "home",
    title: "Pricing",
  },
  {
    path: "/pp",
    view: Privacy,
    layout: "home",
    title: "Privacy Policy",
  },
  {
    path: "/tos",
    view: Terms,
    layout: "home",
    title: "Terms & Conditions",
  },
  {
    path: "/public/intake/:token",
    view: PublicIntakeStart,
    layout: "onboarding",
    title: "Verify your identity",
    skin: "identitycheck",
  },
  {
    path: "/public/verification/:id",
    view: PublicVerificationEntry,
    layout: "onboarding",
    title: "Verification",
    skin: "identitycheck",
  },
  {
    path: "/public/tranche2/verification/:id",
    view: Tranche2Verification,
    layout: "onboarding",
    title: "Tranche 2 Verification",
    skin: "identitycheck",
  },
  {
    path: "/public/risk-assessment/v1/:id",
    view: PublicRiskAssessmentView,
    layout: "onboarding",
    title: "Risk Assessment Review",
    skin: "identitycheck",
  },
  {
    path: "/public/edd/:id",
    view: PublicEddView,
    layout: "onboarding",
    title: "Enhanced Due Diligence",
    skin: "identitycheck",
  },
  {
    path: "/public/response/:id",
    view: ResponseView,
    layout: "response",
    title: "Form Response",
    skin: "identitycheck",
  },
  {
    path: "/public/mcp",
    view: McKinleyPlowmanResponse,
    layout: "preMcKinleyResponse",
    title: "McKinley Plowman Year End Questionnaire",
    skin: "identitycheck",
  },
  {
    path: "/public/demo",
    view: DemoITRResponse,
    layout: "preMcKinleyResponse",
    title: "Demo Year End Questionnaire Demo",
    skin: "identitycheck",
  },
  {
    path: "/public/supervision-group",
    view: SuperResponseFormView,
    layout: "preMcKinleyResponse",
    title: "Supervision Form",
    skin: "identitycheck",
  },
  {
    path: "/public/efs-fact-finder",
    view: EfsFactFinderResponse,
    layout: "preMcKinleyResponse",
    title: "Short Form Financial Fact Finder",
    skin: "identitycheck",
  },
  {
    path: "/public/pre_hs/:id",
    view: PreHsResponseFormView,
    layout: "preResponse",
    title: "Pre HubSpot Form",
    skin: "identitycheck",
  },
  {
    path: "/public/hs/:id",
    view:  HsResponseFormView,
    layout: "preResponse",
    title: "Pre HubSpot Form",
    skin: "identitycheck",
  },
  {
    path: "/onboarding/:id",
    view: PreVerificationFormView,
    layout: "onboarding",
    title: "Onboarding Form",
    skin: "identitycheck",
  },
  {
    path: "/client-onboarding/:id",
    view: ClientOnboardingFormView,
    layout: "onboarding",
    title: "Client Onboarding",
    skin: "identitycheck",
  },
  {
    path: "/client-onboarding-v2/:id",
    view: ClientOnboardingV2FormView,
    layout: "onboarding",
    title: "Client Onboarding",
    skin: "identitycheck",
  },
  {
    path: "/eula",
    view: EULA,
    layout: "home",
    title: "End User Licence Agreement",
  },
  {
    path: "/integrations/documentation",
    view: DocsPublicView,
    layout: "home",
    title: "Docs",
  },
  {
    path: "/finish",
    view: FinishVerification,
    layout: "onboarding",
    title: "Finish Verification",
    skin: "identitycheck",
  },
  {
    path: "/report-requested",
    view: ReportRequested,
    layout: "onboarding",
    title: "Verification Report is being generated",
    skin: "identitycheck",
  },
  {
    path: "/integration/trigger/:token",
    view: IntegrationTriggerConfirm,
    layout: "onboarding",
    title: "Send Verification",
    skin: "identitycheck",
  },
];

export default Routes;
